import { render } from "./ListBlockView.vue?vue&type=template&id=9929052a&scoped=true&ts=true"
import script from "./ListBlockView.vue?vue&type=script&lang=ts"
export * from "./ListBlockView.vue?vue&type=script&lang=ts"

import "./ListBlockView.vue?vue&type=style&index=0&id=9929052a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9929052a"]])

export default __exports__